import {Box} from "@mui/material";
import {FC} from "react";
import {useParams} from "react-router-dom";
import {makeStyles} from "tss-react/mui";
import {LessonPage} from "./LessonPage/LessonPage";
import {QuizPage} from "./QuizPage/QuizPage";
import {SurveyPage} from "./SurveyPage/SurveyPage";

const useStyles = makeStyles<{moduleType?: string}>()((theme, {moduleType}) => ({
	pageBase: {
		height: "100%",
		"& [class*='background']": moduleType !== "quiz" && {
			backgroundColor: "white",
			[theme.breakpoints.down("sm")]: {
				backgroundColor: "#F2F1F4"
			}
		}
	}
}));

export const ModulePage: FC = () => {
	const {moduleSlug} = useParams();
	const {moduleType} = useParams();
	const {classes} = useStyles({moduleType});

	if(!moduleSlug) return <></>;

	return (
		<Box className={classes.pageBase} >
			{moduleType === "lesson" && <LessonPage />}
			{moduleType === "quiz" && <QuizPage />}
			{moduleType === "survey" && <SurveyPage />}
		</Box>
	);
}